<template>
  <div>
    <v-container fluid>
      <v-row justify="end" class="mb-4">
        <v-switch v-model="disable3d" inset hide-details color="black" />
          <span class="mr-3 font-weight-medium mt-5">3D Mode</span>
      </v-row>

      <v-row
        class="mt-5"
        style="min-height: 70vh"
        justify="center"
        align="center"
        dense
      >
        <carousel-3d
          v-if="menuConfig.length"
          :controls-visible="true"
          :clickable="false"
          :disable3d="!disable3d"
          :space="!disable3d ? 356 : 250"
          :width="340"
          :height="480"
          :border="0"
        >
          <slide v-for="(card, i) in menuConfig" :key="card.key" :index="i">
            <figure
              class="zoom"
              style="
                cursor: pointer;
                background-color: aliceblue;
                border-radius: 30px;
              "
            >
              <img
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="480px"
                :src="card.src"
                @click="NavigatePage(card.description)"
              />

              <figcaption>
                {{ card.description }}
              </figcaption>
            </figure>
          </slide>
        </carousel-3d>
      </v-row>
    </v-container>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium">
          Loading, please wait...
        </span>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import enurl from "@/api/environment";
import axios from "axios";
import { Carousel3d, Slide } from "vue-carousel-3d";

export default {
  name: "MainMenu",
  components: {
    Carousel3d,
    Slide,
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      menu: {},
      disable3d: true,
      menuConfig: [],
    };
  },

  computed: {},

  watch: {
    disable3d(val) {
      const d = new Date();
      d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000);
      document.cookie = `3D=${val};expires=${d.toUTCString()};path=/`;
    },
  },

  async mounted() {
    let self = this;
    self.getDataMenuPermission();
    this.disable3d = true;
    const cookie3d = this.$cookies.get("3D");
    this.disable3d = cookie3d === true || cookie3d === "true";
  },

  methods: {
    getDataMenuPermission() {
      this.LoadingDialog = true;
      axios
        .get(`${this.url}Permission/getDataMenuPermission`)
        .then((response) => {
          if (response.data.status !== 0) return;
          const raw = response.data.data || [];
          const flat = raw.flat();
          this.menuConfig = flat.map((item) => {
            let src = require("@/assets/meetingroom.jpg");
            if (item.groupID === 2) src = require("@/assets/bag.jpg");
            if (item.groupID === 3) src = require("@/assets/estamp.jpg");
            if (item.groupID === 4) src = require("@/assets/reserve.jpg");
            if (item.groupID === 5) src = require("@/assets/roompad.jpg");
            if (item.groupID === 6) src = require("@/assets/transaction2.jpg");
            return {
              key: item.appName,
              description: item.groupName,
              groupID: item.groupID,
              src,
            };
          });
        })
        .catch((error) => {
          console.warn(error);
        })
        .finally(() => {
          this.LoadingDialog = false;
        });
    },

    NavigatePage(key) {
      localStorage.setItem("FirstPage", "true");
      switch (key) {
        case "Meeting Room":
          localStorage.setItem("GroupId", 1);
          this.$router.push("/Blank");
          localStorage.setItem("page", "Blank");
          break;
        case "Infrastructure":
          localStorage.setItem("GroupId", 2);
          this.$router.push("/Blank");
          localStorage.setItem("page", "Blank");
          break;
        case "Settings":
          localStorage.setItem("GroupId", 3);
          this.$router.push("/Blank");
          localStorage.setItem("page", "Blank");
          break;
        case "Reservation Condition":
          localStorage.setItem("GroupId", 4);
          this.$router.push("/Blank");
          localStorage.setItem("page", "Blank");
          break;
        case "Room Pad":
          localStorage.setItem("GroupId", 5);
          this.$router.push("/Blank");
          localStorage.setItem("page", "Blank");
          break;
        case "Transaction RoomBooking":
          localStorage.setItem("GroupId", 6);
          this.$router.push("/Blank");
          localStorage.setItem("page", "Blank");
          break;
      }
    },

    changeLang(lang) {
      this.$i18n.locale = lang;
    },
  },
};
</script>
<style scoped>
.zoom {
  z-index: 99;
  transition: transform 0.3s;
}

.zoom:hover {
  transform: scale(1.05);
}
.carousel-card:hover {
  transform: scale(1.05);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
}

.carousel-3d-container figure {
  margin: 0;
}

.carousel-3d-container figcaption {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  bottom: 0;
  position: absolute;
  bottom: 0;
  padding: 15px;
  font-size: 20px;
  min-width: 100%;
  box-sizing: border-box;
  text-align: center;
}

.carousel-3d-slide {
  border-radius: 10px;
  border-color: grey;
}
.custom-red .v-input--selection-controls__input div {
  color: #6a1b9a;
}
</style>
  